import { Flame } from "lucide-react";

const MILESTONES = [7, 30, 90];

export function StreakChip(props: { days: number; compact?: boolean }) {
  const dim = props.days <= 0;
  const tip = `Streak milestones: ${MILESTONES.join(" / ")} consecutive working days`;
  return (
    <span
      title={tip}
      aria-label={`Logging streak: ${props.days} consecutive working day${props.days === 1 ? "" : "s"}`}
      className={[
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1",
        dim
          ? "bg-gray-100/60 text-gray-500 ring-gray-200/60 dark:bg-zinc-800/40 dark:text-gray-500 dark:ring-zinc-700/40"
          : "bg-orange-50 text-orange-700 ring-orange-200 dark:bg-orange-950/30 dark:text-orange-200 dark:ring-orange-800/50",
      ].join(" ")}
    >
      <Flame className={props.compact ? "h-3 w-3" : "h-3.5 w-3.5"} aria-hidden="true" />
      <span className="tabular-nums">{props.days}d</span>
    </span>
  );
}
